import { BASE_PATH, isValidRoomCode } from "../src/protocol";
import { initConsent } from "./consent";
import { renderHome } from "./home";
import { LANG } from "./i18n";
import { renderRoom } from "./room";
import { STRINGS } from "./strings";

const ROOM_PATH = new RegExp(`^${BASE_PATH}/r/([^/]+)/?$`);

function route(): void {
  document.documentElement.lang = LANG;
  document.title = STRINGS.pageTitle;

  const root = document.getElementById("app");
  if (!root) return;

  const match = ROOM_PATH.exec(location.pathname);
  if (!match) {
    renderHome(root);
    return;
  }
  // Rooms are private and temporary: keep them out of search results (the Worker also sends
  // an X-Robots-Tag header for /r/ pages).
  document.head.append(Object.assign(document.createElement("meta"), { name: "robots", content: "noindex, nofollow" }));
  const code = decodeURIComponent(match[1]!).toUpperCase();
  if (isValidRoomCode(code)) {
    renderRoom(root, code);
  } else {
    history.replaceState(null, "", `${BASE_PATH}/`);
    renderHome(root, STRINGS.invalidRoomLink);
  }
}

route();
initConsent();
